import React, { useEffect, useState, useMemo } from "react";  
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";  
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import getBackendUrl from "../../../environment/BackendService";  
import { useLocation } from "react-router-dom";  
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";  
import { useToast } from "../../../common_nextgen/hooks/ToastContext";  
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
  
const usePrescriberNetworks = () => { 
  const { axios_helper_no_header } = useAxios(); 
  const [data, setData] = useState([]);     
  const [first, setFirst] = useState(0);  
  const [rows, setRows] = useState(10);  
  const [totalRecords, setTotalRecords] = useState(0);  
  const [rowData, setRowData] = useState("");  
  const [currentPage, setCurrentPage] = useState(0);      
  const [selectedRows, setSelectedRows] = useState([]);     
  const navigateToPage = useCustomNavigate();  
  const [dropdownValues, setDropdownValues] = useState({});  
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);  
  const [selectedOption, setSelectedOption] = useState("no");  
  const toast = useToast();  
  const location = useLocation();
  
  const [stateVal, setStateVal] = useState(location.state || []);
  const { currentState, previousState } = useMemo(() => {
    let [currentState = {}] = [...stateVal].reverse();
    const previousState = [...stateVal];
    previousState.splice(stateVal.length - 1, 1);
    return {
      previousState,
      currentState,
    };
  }, [stateVal]);

  const {
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.ADDITIONAL_PATIENT_PAY,
    currentIndex: initialIndex = 0,
    externalMode: initialExternalMode = false,
  } = currentState;
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [externalMode, setExternalMode] = useState(initialExternalMode);
  

  const [paramsData, setParamsData] = useState({
    zpr0hj: selectedSchedules?.[initialIndex]?.dp3DiscountTableId,
    zcteio: selectedSchedules?.[initialIndex]?.dp3DiscountTableDesc   
  });

  const {  
    ADD_PRICE_SCHEDULE,  
    EDIT_PRICE_SCHEDULE,  
    DISPLAY_PRICE_SCHEDULE,  
    COPY_PRICE_SCHEDULE,  
    PRICE_SCHEDULE_NOTE,  
  } = ROUTE_PATHS;  
  
  const screen_title = "Prescriber Networks for Discount Table";  
  const screenNumber = "RCWDT002";  
  
  /* Search form fields that needs to be shown for filtering */  
  const formFields = [  
    {  
      fieldLabel: "Discount Table",  
      name: "zpr0hj",  
      label: "Discount Table",  
      type: "text",  
      fieldNature: "readOnly",  
      value: "",  
      maxLength: 10,  
    },  
    {  
      fieldLabel: "Description",  
      name: "zcteio",  
      label: "Description",  
      type: "text",  
      fieldNature: "readOnly",  
      value: "",  
      maxLength: 25,  
    },  
  ];  
  
  /* ACTION BUTTONS info that needs to be displayed on the page */  
  const ctaButtons = [      
    {  
      button_label: "Export as CSV",  
      button_handeler: () => {  
        exportAsCSV();  
      },  
      button_key: "",  
    },  
  ]; 
  
  /* Top Left Back button info that needs to be displayed on the page*/
  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (externalMode) {
          const message = {
            message: "navigate-to-external-program",
            url: previousScreen,
            parameters: {
              state: [...previousState],
            },
          };
          console.log("back messages", message);
          window.parent.postMessage(message, "*");
        } else if (currentIndex < selectedSchedules.length - 1) {
          setCurrentIndex(currentIndex + 1);
        } else {
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12",
    },
  ];
  
  /* Gear Icon Menu option CTAs */  
  const menuOptions = [  
    {  
      label: "Display",  
      icon: <span className="material-icons">visibility</span>,  
      command: () => {  
        const message = {
          message: "navigate-to-presto",
          programCode: "RCPPN005I",
          parameters: {
            planCode:rowData["planCode"],
            mdNetworkId: rowData["networkId"],
            planEffDate:rowData["planEffDate"],
            wrkDescription25:"",
            pgmMessageCode:"",
            planName:rowData["planCode"],
            pgmMessageType:"",
            planTermDate:"",
          },
        };    
        console.log("message",message)    
        window.top?.postMessage(message, "*"); 
      },  
    },  
    {  
      label: "Prescribers",  
      icon: <span className="material-icons">person</span>,  
      command: () => {
        validatePrescriberNavigation();  
        
      },  
    },  
  ]; 
  
  const validatePrescriberNavigation = () =>{
    const params = {planCode:rowData.planCode};
    axios_helper_no_header(
      "GET",
      "api/rcppnp/validateBeforeNavigatingToPrescriber",
      null,
      params 
    )
      .then((response) => {
        const message = {
          message: "navigate-to-presto",
          programCode: "RCMDN002I",
          parameters: {
            mdNetworkId: rowData["networkId"],
            prfPrescriberId: "",
            prqPrscrbrIdQualifier:"",
            prfPrescriberIdState: "",
          },
        };        
        window.top?.postMessage(message, "*");
      })
      .catch((error) => {
        const { responseStatus: { displayErrorFields = null, message } = {} } =
          error.data;
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      });
  }
  
  /* Data table column info. */  
  const columnDef = [  
    {  
      header: "Network",  
      field: "networkId",  
    },  
    {  
      header: "Description",  
      field: "networkDesc",  
    },  
    {  
      header: "Plan",  
      field: "planCode",  
    },  
  ];  
  
  /* Param Key which used as bridge between various operations on tabluar data */  
  const parmKey = "zpr0hj";  
  
  /* Handler that fetches the data */  
  const fetchData = async () => {  
    console.log("fetch data");  
    const page = first / rows;  
    try {  
      const raw_response = await axios_helper_no_header(  
        "GET",  
        `api/rcppnp`,  
        null,  
        {  
          discountTableId: selectedSchedules[currentIndex].dp3DiscountTableId,
          page: page,  
          size: rows           
        }  
      );  
      const response = raw_response.responseData;  
      const pageResponse = raw_response.responsePaginationDTO;  
      if (response.length === 0) {  
        setData([]);  
        setTotalRecords(0);  
        console.log("response.length is ", response.length);  
        toast.current.show({  
          severity: "info",  
          summary: "",  
          detail: response.responseStatus.message,  
          life: 3000,  
        });  
      } else {  
        setData(response);  
        console.log("response", response);  
        console.log(pageResponse.totalRecords);  
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords  
      }  
    } catch (error) {  
      console.error("Error fetching data:", error);  
      setData([]);  
      setTotalRecords(0);  
    }  
  };  
  
 useEffect(() => {
   if (!selectedSchedules?.[currentIndex]?.dp3DiscountTableId) return;
   fetchData();
 }, [paramsData, rows, currentPage, selectedOption, selectedSchedules]);
  
  useEffect(() => {
    setParamsData({
      zpr0hj: selectedSchedules?.[currentIndex]?.dp3DiscountTableId,
      zcteio: selectedSchedules?.[currentIndex]?.dp3DiscountTableDesc       
    })
  }, [currentIndex]);
  
  const onPageChange = (event) => {       
    setFirst(event.first);  
    setCurrentPage(event.page);  
    setRows(event.rows);  
  };   

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ discountTableId: selectedSchedules[currentIndex].dp3DiscountTableId });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rcppnp/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };
  
  const updateParamData = (data) => {  
    setFirst(0);  
    setCurrentPage(0);  
    setParamsData(data);  
  };  

  const handleMessage = (event) => {
    const { type, data } = event.data;
    console.log("iframe load", type, data);
    if (type === "set-params") {
      const { currentIndex = 0, selectedSchedules = []} = data[data.length - 1] || {};
      setStateVal(data);
      setExternalMode(true);
      if (selectedSchedules.length) {
        setParamsData({
          zpr0hj: selectedSchedules?.[currentIndex]?.dp3DiscountTableId,
          zcteio: selectedSchedules?.[currentIndex]?.dp3DiscountTableDesc,
        });
      }
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });
  
  return {  
    screenNumber,  
    screen_title,  
    formFields,  
    dropdownValues,  
    paramsData,  
    updateParamData,  
    ctaButtons,  
    leftButtons,
    data,  
    parmKey,  
    menuOptions,  
    columnDef,  
    setRowData,  
    selectedRows,  
    setSelectedRows,  
    first,  
    rows,  
    totalRecords,  
    currentPage,  
    onPageChange,  
    isConfirmationModalOpen,      
    setSelectedOption,  
  };  
};  
  
export default usePrescriberNetworks;  
